import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { motion, MotionConfig } from "framer-motion";
import React from "react";
import { Link } from "react-router-dom";

interface AgendaCelebrationCardProps {
    to: string;
    name: string;
}

export const AgendaCelebrationCard: React.FC<AgendaCelebrationCardProps> = ({
    to,
    name,
}) => (
    <MotionConfig reducedMotion="user">
        <motion.div
            layout
            initial={{ opacity: 0, scale: 0.96 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ type: "spring", stiffness: 400, damping: 24 }}
            className="rounded-lg bg-green-50 p-4 ring-1 ring-green-300 sm:p-5">
            <div className="flex items-center gap-3">
                <motion.span
                    aria-hidden="true"
                    className="leading-none text-green-600"
                    initial={{ scale: 0.4, rotate: -25 }}
                    animate={{ scale: 1, rotate: 0 }}
                    transition={{
                        type: "spring",
                        stiffness: 500,
                        damping: 11,
                        delay: 0.1,
                    }}>
                    <CheckCircleIcon className="h-7 w-7 flex-shrink-0" />
                </motion.span>
                <div className="min-w-0">
                    <Link
                        to={to}
                        className="block truncate font-semibold text-gray-900 hover:underline">
                        {name}
                    </Link>
                    <p className="text-sm font-medium text-green-800">
                        That&apos;s everything for now — nice work!
                    </p>
                </div>
            </div>
        </motion.div>
    </MotionConfig>
);
